"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePlacementSlipDto = exports.FeeDetailsDto = exports.RemarksDto = exports.OtherDeatilsDto = exports.PolicyDetailsDto = exports.InstallmentDateDto = exports.PlacementSlipDocumentDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
class PlacementSlipDocumentDto {
}
exports.PlacementSlipDocumentDto = PlacementSlipDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], PlacementSlipDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 35,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], PlacementSlipDocumentDto.prototype, "documentId", void 0);
class InstallmentDateDto {
}
exports.InstallmentDateDto = InstallmentDateDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-06-06" }),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)({ message: "First installment date is required." }),
    tslib_1.__metadata("design:type", String)
], InstallmentDateDto.prototype, "firstInstallmentDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-06-13" }),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Second installment date is required." }),
    tslib_1.__metadata("design:type", String)
], InstallmentDateDto.prototype, "secondInstallmentDate", void 0);
class TPAMapDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 101, description: "Unique identifier for the TPA." }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "TPA ID is required." }),
    tslib_1.__metadata("design:type", Number)
], TPAMapDto.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 201,
        description: "Unique identifier for the TPA location.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "TPA Location ID is required." }),
    tslib_1.__metadata("design:type", Number)
], TPAMapDto.prototype, "tpaLocationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 301,
        description: "Unique identifier for the TPA branch.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "TPA Branch ID is required." }),
    tslib_1.__metadata("design:type", Number)
], TPAMapDto.prototype, "tpaBranchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 401,
        description: "Unique identifier for the TPA contact.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], TPAMapDto.prototype, "tpaContactId", void 0);
class InsurerMapDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 201,
        description: "Unique identifier for the insurer.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer ID is required." }),
    tslib_1.__metadata("design:type", Number)
], InsurerMapDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 301,
        description: "Unique identifier for the insurer location.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer Location ID is required." }),
    tslib_1.__metadata("design:type", Number)
], InsurerMapDto.prototype, "insurerLocationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 401,
        description: "Unique identifier for the insurer branch.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer Branch ID is required." }),
    tslib_1.__metadata("design:type", Number)
], InsurerMapDto.prototype, "insurerBranchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 501,
        description: "Unique identifier for the insurer contact.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer Contact ID is required." }),
    tslib_1.__metadata("design:type", Number)
], InsurerMapDto.prototype, "insurerContactId", void 0);
class SharingDetailDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 201,
        description: "Unique identifier for the insurer.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer ID is required." }),
    tslib_1.__metadata("design:type", Number)
], SharingDetailDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 25.5,
        description: "Percentage of sharing allocated to the office.",
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Share percentage is required." }),
    tslib_1.__metadata("design:type", Number)
], SharingDetailDto.prototype, "sharePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 12.5,
        description: "Brokerage percentage allocated to the office.",
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage percentage is required." }),
    tslib_1.__metadata("design:type", Number)
], SharingDetailDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1000,
        description: "Brokerage amount allocated to the office.",
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage amount is required." }),
    tslib_1.__metadata("design:type", Number)
], SharingDetailDto.prototype, "brokerageAmount", void 0);
class CDDetailDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Type of payment type.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Payment Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CDDetailDto.prototype, "paymentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Type of CD account.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "CD Account Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CDDetailDto.prototype, "cdAccountTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Saving Account",
        description: "Type of Account name",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CDDetailDto.prototype, "accountName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 78, description: "Open balance" }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CDDetailDto.prototype, "openBalance", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 78, description: "Selected CD Account" }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CDDetailDto.prototype, "selectCdAccount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 440, description: "Transaction Type" }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CDDetailDto.prototype, "transactionTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2023-10-01",
        description: "Cheque Date",
    }),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CDDetailDto.prototype, "chequeDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1000.5,
        description: "Amount associated with the cheque.",
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CDDetailDto.prototype, "chequeAmount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "123456",
        description: "Cheque number.",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CDDetailDto.prototype, "chequeNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Bank of America",
        description: "Name of the bank.",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CDDetailDto.prototype, "bankName", void 0);
class PolicyDetailsDto {
}
exports.PolicyDetailsDto = PolicyDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-06-01",
        description: "Start date of the policy.",
    }),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy start date is required." }),
    tslib_1.__metadata("design:type", String)
], PolicyDetailsDto.prototype, "policyFromDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2026-05-31",
        description: "End date of the policy.",
    }),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy end date is required." }),
    tslib_1.__metadata("design:type", String)
], PolicyDetailsDto.prototype, "policyToDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000000, description: "Total sum insured." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Sum insured is required." }),
    tslib_1.__metadata("design:type", Number)
], PolicyDetailsDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 50000, description: "Basic premium amount." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Basic premium is required." }),
    tslib_1.__metadata("design:type", Number)
], PolicyDetailsDto.prototype, "basicPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Indicates if premium is installment-based (1 for true, 0 for false).",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Premium installment based is required." }),
    tslib_1.__metadata("design:type", Number)
], PolicyDetailsDto.prototype, "isPremiumInstallmentBased", void 0);
class OtherDeatilsDto {
}
exports.OtherDeatilsDto = OtherDeatilsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 999,
        description: "Unique identifier for the lead insurer.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Lead Insurer ID is required." }),
    tslib_1.__metadata("design:type", Number)
], OtherDeatilsDto.prototype, "leadInsurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Indicates if the lead insurer pays commission (1 for true, 0 for false).",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Lead Insurer Pay Commission is required." }),
    tslib_1.__metadata("design:type", Number)
], OtherDeatilsDto.prototype, "isLeadInsurerPayCommission", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 25,
        description: "Maximum age of dependents allowed.",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Max age of dependents is required." }),
    tslib_1.__metadata("design:type", Number)
], OtherDeatilsDto.prototype, "maxAgeOfDependents", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 12.5, description: "Brokerage percentage." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage percentage is required." }),
    tslib_1.__metadata("design:type", Number)
], OtherDeatilsDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 341,
        description: "Type of policy placement.(Single or multiple insurers)",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], OtherDeatilsDto.prototype, "policyPlacedTypeLid", void 0);
class RemarksDto {
}
exports.RemarksDto = RemarksDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "This is a sample placement slip.",
        description: "Additional remarks (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], RemarksDto.prototype, "remarks", void 0);
class FeeDetailsDto {
}
exports.FeeDetailsDto = FeeDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 2000, description: "Fee amount." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Fee amount is required." }),
    tslib_1.__metadata("design:type", Number)
], FeeDetailsDto.prototype, "fee", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 0,
        description: "Indicates if fee is installment-based (1 for true, 0 for false).",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Fee installment based is required." }),
    tslib_1.__metadata("design:type", Number)
], FeeDetailsDto.prototype, "isFeeInInstallment", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 5,
        description: "Percentage of terrorism commission.",
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], FeeDetailsDto.prototype, "terrorismCommissionPercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 18, description: "Service tax percentage." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Service Tax Percentage is required" }),
    tslib_1.__metadata("design:type", Number)
], FeeDetailsDto.prototype, "serviceTaxPercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 9000, description: "Service tax amount." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Service Tax Amount is required" }),
    tslib_1.__metadata("design:type", Number)
], FeeDetailsDto.prototype, "serviceTaxAmount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Additional cover info",
        description: "Additional information about the cover.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], FeeDetailsDto.prototype, "other", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 59000, description: "Total premium amount." }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Total premium is required" }),
    tslib_1.__metadata("design:type", Number)
], FeeDetailsDto.prototype, "totalPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-05-29",
        description: "Date of the placement slip.",
    }),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Placement slip date is required." }),
    tslib_1.__metadata("design:type", String)
], FeeDetailsDto.prototype, "placementSlipDate", void 0);
class CreatePlacementSlipDto {
}
exports.CreatePlacementSlipDto = CreatePlacementSlipDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 391,
        description: "Unique identifier for the opportunity activity.",
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity Activity ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity Activity ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreatePlacementSlipDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Status (1 for submitted, 0 for not submitted).",
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Status is required." }),
    tslib_1.__metadata("design:type", Number)
], CreatePlacementSlipDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: PolicyDetailsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PolicyDetailsDto),
    tslib_1.__metadata("design:type", PolicyDetailsDto)
], CreatePlacementSlipDto.prototype, "policyDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [InstallmentDateDto],
        description: "List of Installment Date.",
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => InstallmentDateDto),
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], CreatePlacementSlipDto.prototype, "installmentDates", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: FeeDetailsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => FeeDetailsDto),
    tslib_1.__metadata("design:type", FeeDetailsDto)
], CreatePlacementSlipDto.prototype, "feeDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [InsurerMapDto],
        description: "List of insurer mappings.",
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => InsurerMapDto),
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], CreatePlacementSlipDto.prototype, "insurerDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [TPAMapDto], description: "List of TPA mappings." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => TPAMapDto),
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], CreatePlacementSlipDto.prototype, "tpaDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: OtherDeatilsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OtherDeatilsDto),
    tslib_1.__metadata("design:type", OtherDeatilsDto)
], CreatePlacementSlipDto.prototype, "otherDeatils", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [SharingDetailDto],
        description: "List of sharing details.",
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SharingDetailDto),
    (0, class_validator_1.IsArray)(),
    tslib_1.__metadata("design:type", Array)
], CreatePlacementSlipDto.prototype, "insurerAndBrokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: CDDetailDto,
        description: "List of condition details.",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CDDetailDto),
    tslib_1.__metadata("design:type", CDDetailDto)
], CreatePlacementSlipDto.prototype, "cdAccountDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Cover details as key-value pairs",
        example: {
            "101": "This is my policy data",
            "102": "This is my policy number",
            "103": "This is my policy name",
        },
    }),
    (0, class_validator_1.IsObject)({ message: "coverDetails must be an object" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], CreatePlacementSlipDto.prototype, "coverDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: RemarksDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksDto),
    tslib_1.__metadata("design:type", RemarksDto)
], CreatePlacementSlipDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of document objects",
        type: [PlacementSlipDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PlacementSlipDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreatePlacementSlipDto.prototype, "documents", void 0);
